export function toLocalISOStringWithOffset(date = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hour = pad(date.getHours());
  const min = pad(date.getMinutes());
  const sec = pad(date.getSeconds());
  const offset = -date.getTimezoneOffset();
  const sign = offset >= 0 ? '+' : '-';
  const offsetHour = pad(Math.floor(Math.abs(offset) / 60));
  const offsetMin = pad(Math.abs(offset) % 60);
  return `${year}-${month}-${day}T${hour}:${min}:${sec}${sign}${offsetHour}:${offsetMin}`;
}
